export default "__VITE_ASSET__BSudoMiU__"